import styled from '@emotion/styled';
import mediaQuery from '@/lib/styling/mediaQuery';
import { IconButton } from '@mui/material';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import { grey } from '@mui/material/colors';
import isTouchDevice from '@/lib/utils/isTouchDevice';

const ControlsButton = styled(IconButton)(
  ({ theme }) => ({
    position: 'absolute',
    top: 24,
    right: 48,
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    transition: theme.transitions.create([
      'background-color',
      'opacity',
      'transform',
    ]),
    ':hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
    },
    [mediaQuery(560)]: {
      right: 24,
    },
  }),
  () => {
    if (isTouchDevice()) {
      return {
        opacity: '1 !important',
        transform: 'none !important',
      };
    }
  },
  addHighContrastStyles(({ theme }) => ({
    backgroundColor: 'black',
    border: '2px solid white',
    transition: theme.transitions.create([
      'color',
      'background-color',
      'border-color',
      'opacity',
      'transform',
    ]),
    ':hover, :focus': {
      color: 'black',
      backgroundColor: grey[400],
      borderColor: 'black',
    },
  })),
);

export default ControlsButton;
